import {IProductTourStep} from '@toolify/client/src/modules/productTour/types/IProductTourStep'
import {ProductTourAnchorType} from '@toolify/client/src/modules/productTour/enum/ProductTourAnchorType'

// Anchors live inside the Favourites sidebar strategy (start() switches to it).
// Steps whose anchor is missing from the DOM or hidden by CSS (a feature flag,
// the mobile layout, etc.) are skipped at runtime by the store's step navigation.
export const mainProductTourSteps: IProductTourStep[] = [
  {
    name: 'welcome',
    anchor: null,
    titleTranslationKey: 'productTour.main.welcome.title',
    descriptionTranslationKey: 'productTour.main.welcome.description',
  },
  {
    name: 'workspace',
    anchor: ProductTourAnchorType.WorkspaceSwitcher,
    titleTranslationKey: 'productTour.main.workspace.title',
    descriptionTranslationKey: 'productTour.main.workspace.description',
    placement: 'right',
  },
  {
    name: 'spaces',
    anchor: ProductTourAnchorType.SpaceSwitcher,
    titleTranslationKey: 'productTour.main.spaces.title',
    descriptionTranslationKey: 'productTour.main.spaces.description',
    placement: 'right',
  },
  {
    name: 'createResource',
    anchor: ProductTourAnchorType.CreateResourceButton,
    titleTranslationKey: 'productTour.main.createResource.title',
    descriptionTranslationKey: 'productTour.main.createResource.description',
    placement: 'right',
  },
  {
    name: 'resourcesList',
    anchor: ProductTourAnchorType.ResourcesList,
    titleTranslationKey: 'productTour.main.resourcesList.title',
    descriptionTranslationKey: 'productTour.main.resourcesList.description',
    placement: 'right',
  },
  {
    name: 'search',
    anchor: ProductTourAnchorType.QuickNavigationSearch,
    titleTranslationKey: 'productTour.main.search.title',
    descriptionTranslationKey: 'productTour.main.search.description',
    placement: 'right',
  },
  {
    name: 'talk',
    anchor: ProductTourAnchorType.QuickNavigationTalk,
    titleTranslationKey: 'productTour.main.talk.title',
    descriptionTranslationKey: 'productTour.main.talk.description',
    placement: 'right',
  },
  {
    name: 'notifications',
    anchor: ProductTourAnchorType.NotificationsButton,
    titleTranslationKey: 'productTour.main.notifications.title',
    descriptionTranslationKey: 'productTour.main.notifications.description',
    placement: 'top',
  },
  {
    name: 'profile',
    anchor: ProductTourAnchorType.UserProfile,
    titleTranslationKey: 'productTour.main.profile.title',
    descriptionTranslationKey: 'productTour.main.profile.description',
    placement: 'top',
  },
  {
    name: 'finish',
    anchor: null,
    titleTranslationKey: 'productTour.main.finish.title',
    descriptionTranslationKey: 'productTour.main.finish.description',
  },
]
